import React from 'react';
import axios from 'axios';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import 'moment/locale/cs';
import { Line } from 'react-chartjs-2';
import { Button } from "react-bootstrap";
import stats  from './accessStats';

class AccessLog extends React.Component {
  constructor(props) {
    super(props);
    moment().locale('cs');
    this.state = {
      year: moment.utc('2017-10-01').get('year'),
      month: moment.utc('2017-10-01').get("month"),
      lastYearCount: null,
      lastHalfYearCount: null,
      lastMonthCount: null,
      lastWeekCount: null,
      lastDayCount: null,
      periodCount: null,
      loaded: false,
      chartData: this.init_chart()
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeYear = this.handleChangeYear.bind(this);
    this.handleChangeMonth= this.handleChangeMonth.bind(this);
    this.handleLastWeekToChart = this.handleLastWeekToChart.bind(this);
    this.handleLastMonthToChart = this.handleLastMonthToChart.bind(this);
    this.handleLastHalfYearToChart = this.handleLastHalfYearToChart.bind(this);
    this.handleLastYearToChart = this.handleLastYearToChart.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.active && !this.state.loaded) {
      this.getLastYearCount();
      this.getLastHalfYearCount();
      this.getLastMonthCount();
      this.getLastWeekCount();
      this.getLastDayCount();
      this.getPeriod(this.state.year, this.state.month);
      this.getChartData(this.state.year, this.state.month);
      this.setState({
        loaded: true,
      });
    }
  }


  // datapicker handles
  handleChangeYear(e) {
    this.setState({
      year: Number(e.target.value),
      month: ''
    })
  }

  handleChangeMonth(e) {
    this.setState({ month: Number(e.target.value) });
  }

  handleSubmit(event) {
    const { year, month } = this.state;
    event.preventDefault();
    this.getPeriod(year, month);
  }

  // to chart handles
  handleLastWeekToChart() {
    let startDate = moment.utc().startOf('day').subtract(1, 'w');
    let endDate = moment.utc().endOf('day');
    this.setState({
      startDate,
      endDate
    });
    this.getChartData(startDate, endDate);
    this.getPeriod(startDate, endDate);
  }

  handleLastMonthToChart() {
    let startDate = moment.utc().startOf('day').subtract(1, 'M');
    let endDate = moment.utc().endOf('day');
    this.setState({
      startDate,
      endDate
    });
    this.getChartData(startDate, endDate);
    this.getPeriod(startDate, endDate);
  }

  handleLastHalfYearToChart() {
    let startDate = moment.utc().startOf('day').subtract(6, 'M');
    let endDate = moment.utc().endOf('day');
    this.setState({
      startDate,
      endDate
    });
    this.getChartData(startDate, endDate);
    this.getPeriod(startDate, endDate);
  }

  handleLastYearToChart() {
    let startDate = moment.utc().startOf('day').subtract(1, 'y');
    let endDate = moment.utc().endOf('day');
    this.setState({
      startDate,
      endDate
    });
    this.getChartData(startDate, endDate);
    this.getPeriod(startDate, endDate);
  }

  getPeriod(year, month) {
    let loginToken = this.props.sessionData.accessToken;
    let config = {
      headers: {
        'Authorization': 'Bearer ' + loginToken
      }
    };
    const from = moment([2017, 9]).startOf('month');
    const to = moment([year, month]).endOf( 'month');
    axios.post(this.props.api.stats.accessLogs, {
      from,
      to,
    }, config).then((result) => {
      if (!this._calledComponentWillUnmount) {
        result = stats;
        this.setState({
          periodCount: result.data[year] && result.data[year][month + 1] ? result.data[year][month + 1] : undefined,
        });
      }
    }).catch((error) => {
      console.log('Error axios:', error);
    });
  }

  getLastYearCount() {
    let loginToken = this.props.sessionData.accessToken;
    let config = {
      headers: {
        'Authorization': 'Bearer ' + loginToken
      }
    };
    axios.post(this.props.api.stats.accessLogs, {
      from: moment.utc().startOf('day').subtract(1, 'year'),
      to: moment.utc().endOf('day')
    }, config).then((result) => {
      if (!this._calledComponentWillUnmount) {
        this.setState({
          lastYearCount: result.data ? result.data : 0
        });
      }
    }).catch((error) => {
      console.log('Error axios:', error);
    });
  }

  getLastHalfYearCount() {
    let loginToken = this.props.sessionData.accessToken;
    let config = {
      headers: {
        'Authorization': 'Bearer ' + loginToken
      }
    };
    axios.post(this.props.api.stats.accessLogs, {
      from: moment.utc().startOf('day').subtract(6, 'months'),
      to: moment.utc().endOf('day')
    }, config).then((result) => {
      if (!this._calledComponentWillUnmount) {
        this.setState({
          lastHalfYearCount: result.data ? result.data : 0
        });
      }
    }).catch((error) => {
      console.log('Error axios:', error);
    });
  }

  getLastMonthCount() {
    let loginToken = this.props.sessionData.accessToken;
    let config = {
      headers: {
        'Authorization': 'Bearer ' + loginToken
      }
    };
    axios.post(this.props.api.stats.accessLogs, {
      from: moment.utc().subtract(1, 'M'),
      to: moment.utc()
    }, config).then((result) => {
      if (!this._calledComponentWillUnmount) {
        this.setState({
          lastMonthCount: result.data ? result.data : 0
        });
      }
    }).catch((error) => {
      console.log('Error axios:', error);
    });
  }

  getLastWeekCount() {
    let loginToken = this.props.sessionData.accessToken;
    let config = {
      headers: {
        'Authorization': 'Bearer ' + loginToken
      }
    };
    axios.post(this.props.api.stats.accessLogs, {
      from: moment.utc().startOf('day').subtract(1, 'week'),
      to: moment.utc().endOf('day')
    }, config).then((result) => {
      if (!this._calledComponentWillUnmount) {
        this.setState({
          lastWeekCount: result.data ? result.data : 0
        });
      }
    }).catch((error) => {
      console.log('Error axios:', error);
    });
  }

  getLastDayCount() {
    let loginToken = this.props.sessionData.accessToken;
    let config = {
      headers: {
        'Authorization': 'Bearer ' + loginToken
      }
    };
    axios.post(this.props.api.stats.accessLogs, {
      from: moment.utc().startOf('day'),
      to: moment.utc().endOf('day')
    }, config).then((result) => {
      if (!this._calledComponentWillUnmount) {
        this.setState({
          lastDayCount: result.data ? result.data : 0
        });
      }
    }).catch((error) => {
      this.setState({
        lastDayCount: 0
      });
      console.log('Error axios:', error);
    });
  }

  getChartData(year, month) {
    let chartData = this.state.chartData;
    let loginToken = this.props.sessionData.accessToken;
    let config = {
      headers: {
        'Authorization': 'Bearer ' + loginToken
      }
    };
    const from = moment([2017, 9]).startOf('month');
    const to = moment([year, month]).endOf( 'month');
    axios.post(this.props.api.stats.accessLogs + "s", {
      from,
      to
    }, config).then((result) => {
      if (!this._calledComponentWillUnmount) {
        result = stats.data;
        let data = [];
        for (const dYear in result) {
          if (result.hasOwnProperty(dYear)) {
            for (const dMonth in result[dYear]) {
              if (result[dYear].hasOwnProperty(dMonth)) {
                const y = Number(dYear);
                const m = Number(dMonth) - 1;
                const date = moment([y, m]).endOf('month');
                data.push({
                  date,
                  count: result[dYear] ? result[dYear][dMonth] : undefined,
                })
              }
            }
          }
        }
        data.sort((a, b) => new Date(a.date) - new Date(b.date));
        chartData.labels = data.map((elem) => moment(elem.date).format('l'));
        chartData.datasets[0].data = data.map((elem) => elem.count);
        this.setState({
          chartData
        });
      }
    }).catch(function (error) {
      console.error('Error axios:', error);
    });
  }

  init_chart() {
    return {
      labels: [],
      datasets: [
        {
          label: 'Počet uživatelů',
          fill: false,
          borderColor: '#007acc',
          backgroundColor: '#007acc',
          pointRadius: 5,
          pointHoverRadius: 10,
          data: []
        }
      ],
      options: {
        responsive: true,
        title: {
          display: true,
          text: 'Počet uživatelů'
        },
        legend: {
          display: false,
        },
        tooltips: {
          mode: 'index',
          intersect: false,
        },
        hover: {
          mode: 'nearest',
          intersect: true
        },
        scales: {
          xAxes: [{
            scaleLabel: {
              display: true,
              labelString: 'Datum'
            }
          }],
          yAxes: [{
            scaleLabel: {
              display: true,
              labelString: 'Počet uživatelů'
            }
          }]
        }
      }
    }
  };

  render() {
    const { year, month } = this.state;
    
    const months = ['leden', 'únor', 'březen', 'duben', 'květen', 'červen', 'červenec', 'srpen', 'září', 'říjen', 'listopad', 'prosinec'];
    
    return (
      <div id="accessLog">
        <div>
          <h3>Počet uživatelů</h3>
        </div>
        <div className="row tile-count">
          <div className="col-lg-2 col-md-4 col-sm-6 tile-stats-count">
            <span className="count-top">Celkem uživatelů</span>
            <div className="count">{this.state.periodCount}</div>
            <span className="count-bottom">ve zvoleném období</span>
          </div>
        </div>
        <form className="form date-chooser" onSubmit={this.handleSubmit}>
          <div className="form-group">
            <select className="form-control" value={year} onChange={this.handleChangeYear}>
              <option value="" className="text-muted">Vyberte rok</option>
              {Object.keys(stats.data).map((y) => (
                <option key={y} value={y} selected={year === y}>{y}</option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <select className="form-control" value={month} onChange={this.handleChangeMonth}>
              <option value="" className="text-muted">Vyberte měsíc</option>
              {stats.data[year] && Object.keys(stats.data[year]).map((m) => (
                <option key={m} value={m - 1}>{months[m - 1]}</option>
              ))}
            </select>
          </div>
          <Button
            type="submit"
            className="btn-primary atDatepicker"
            disabled={year === '' || month === ''}
            onSubmit={this.handleSubmit}>Vybrat
          </Button>
        </form>
        <div className="myChart">
          <Line data={this.state.chartData} options={this.state.chartData.options} />
        </div>
      </div>
    );
  }
}

export default AccessLog;



/** WEBPACK FOOTER **
 ** ./src/containers/Statistics/accessLog.js
 **/